import fp from 'lodash/fp';
import React from 'react';
import { Handles, Rail, Slider, Tracks } from 'react-compound-slider';
import { compose, lifecycle, withProps, withStateHandlers } from 'recompose';

const sliderStyle = {  // Give the slider some width
  position: 'relative',
  width: '100%',
  height: 50
}

const railStyle = {
  position: 'absolute',
  width: '100%',
  height: 10,
  marginTop: 20,
  borderRadius: 5
}

function Handle({
  handle: { id, value, percent },
  getHandleProps
}) {
  return (
    <div
      className='handle'
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: -15,
        marginTop: 15,
        zIndex: 2,
        width: 20,
        height: 20,
        border: 0,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '50%'
      }}
      {...getHandleProps(id)}
    >
    </div>
  )
}

function Track({ source, target, getTrackProps }) {
  return (
    <div
      className='track'
      style={{
        position: 'absolute',
        height: 10,
        zIndex: 1,
        marginTop: 20,
        borderRadius: 5,
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`
      }}
      {...getTrackProps()}
    />
  )
}

export const SliderInput = ({
  max,
  min,
  maxLabel,
  minLabel,
  currentMax,
  currentMin,
  updateMin,
  updateMax,
  step
}) => {

  const onUpdate = ([newMin, newMax]) => {
    updateMax(newMax)
    updateMin(newMin)
  }

  return <div id='slider-input'>
    <div className='slider-labels flexbox justify-between'>
      <div>{minLabel}</div>
      <div>{maxLabel}</div>
    </div>
    <div>
      <Slider
        rootStyle={sliderStyle}
        domain={[min, max]}
        step={step}
        mode={3}
        values={[min, max]}
        onUpdate={onUpdate}
      >
        <Rail>
          {({ getRailProps }) => (
            <div className='rail' style={railStyle} {...getRailProps()} />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map(handle => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    </div>
  </div>
}

export default compose(
  withStateHandlers(
    ({ min, max }) => ({
      currentMin: min,
      currentMax: max
    }),
    {
      updateMin: ({ currentMin }) => (min) => ({
        currentMin: min
      }),
      updateMax: ({ currentMax }) => (max) => ({
        currentMax: max
      })
    }
  ),
  withProps(
    ({
      currentMin,
      currentMax
    }) => ({
      filter: {
        min: currentMin,
        max: currentMax
      }
    })
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (!fp.isEqual(this.props.filter)(prevProps.filter)) {
        this.props.onChange(this.props.filter)
      }
    }
  })
)(SliderInput)


// WEBPACK FOOTER //
// ./src/containers/components/slider-input.js